<button
  type="button"
  role="switch"
  class="tc"
  data-if-glow
  [class.tc--on]="checked()"
  [attr.aria-checked]="checked()"
  [disabled]="disabled()"
  (click)="toggle()"
>
  @if (checked()) {
    <svg class="tc-mark tc-mark--on" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
      <path stroke-linecap="round" stroke-linejoin="round" d="m4.5 12.75 6 6 9-13.5" />
    </svg>
  } @else {
    <svg class="tc-mark tc-mark--off" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true">
      <circle cx="12" cy="12" r="7.5" />
    </svg>
  }
  {{ label() }}
</button>
